import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import FormControl from "@material-ui/core/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormLabel from "@material-ui/core/FormLabel"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"

const useStyles = makeStyles((theme) => ({
  input: {
    background: theme.palette.background.paper,
  },
  radio: {
    // "& .MuiSvgIcon-root": {
    //   background: theme.palette.background.paper,
    // },
  },
  root: {
    // background: theme.palette.background.paper,
    // margin: 0,//theme.spacing(1),
    // width: "100%",//"calc(100% - " + theme.spacing(2) + "px)",
  },
}))

export default function RadioButtonsGroup({
  id,
  label,
  name,
  options,
  defaultValue,
  onChange,
  type,
}) {
  const classes = useStyles()

  return (
    <FormControl component="fieldset" className={classes.root}>
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup
        aria-label={label}
        name={name}
        onChange={onChange}
        row={type === "horizontal" ? true : false}
        value={defaultValue}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio className={classes.radio} />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}
